export default "__VITE_ASSET__BHemxjY3__"